import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TermsAndConditions from "../../pages/home/term-and-conditions/TermsAndConditions";
import {
  Button,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

function TcModal({ open, setOpen }) {
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  return (
    <React.Fragment>
      {/* <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        scroll={'paper'}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogContent
          sx={{
            bgcolor: "var(--neutral-white)",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <TermsAndConditions modal={true} />
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            sx={{ fontSize: "16px", maxWidth: "150px", margin: "auto" }}
          >
            Close
          </Button>
        </DialogContent>
      </Dialog> */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        scroll={"paper"}
        maxWidth="lg"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogContent
          dividers={scroll === "paper"}
          sx={{ backgroundColor: "var(--neutral-white)" }}
        >
          <TermsAndConditions modal={true} />
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "var(--neutral-white)" }}>
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            sx={{ fontSize: "16px", maxWidth: "150px", margin: "auto" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default TcModal;
